import React from 'react';
import { Users, TrendingUp } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getRetentionData } from '../../../../utils/aiBriefingsData';
interface RetentionWidgetProps {
  onExpand?: () => void;
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const RetentionWidget: React.FC<RetentionWidgetProps> = ({
  onExpand,
  onHide,
  onAsk
}) => {
  const data = getRetentionData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Come migliorare retention?'
  }, {
    id: '2',
    text: 'Analisi overlap ecosistema'
  }, {
    id: '3',
    text: 'Confronta con benchmark'
  }];
  return <BentoWidgetCard id="retention" title="Retention & Cohort Snapshot" size="L" lastUpdated="9 min fa" questions={questions} onExpand={onExpand} onHide={onHide} onAsk={onAsk} data-id="element-1555">
      <div className="grid grid-cols-4 gap-3 mb-4" data-id="element-1556">
        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1557">
          <p className="text-xs text-blue-700" data-id="element-1558">WAU</p>
          <p className="text-lg font-bold text-blue-900" data-id="element-1559">
            {data.wau.toLocaleString()}
          </p>
        </div>
        <div className="bg-green-50 rounded-lg p-3" data-id="element-1560">
          <p className="text-xs text-green-700" data-id="element-1561">MAU</p>
          <p className="text-lg font-bold text-green-900" data-id="element-1562">
            {data.mau.toLocaleString()}
          </p>
        </div>
        <div className="bg-purple-50 rounded-lg p-3" data-id="element-1563">
          <p className="text-xs text-purple-700" data-id="element-1564">D7</p>
          <p className="text-lg font-bold text-purple-900" data-id="element-1565">
            {data.d7Retention}%
          </p>
        </div>
        <div className="bg-amber-50 rounded-lg p-3" data-id="element-1566">
          <p className="text-xs text-amber-700" data-id="element-1567">D30</p>
          <p className="text-lg font-bold text-amber-900" data-id="element-1568">
            {data.d30Retention}%
          </p>
        </div>
      </div>

      <div className="h-32 mb-4" data-id="element-1569">
        <ResponsiveContainer width="100%" height="100%" data-id="element-1570">
          <LineChart data={data.cohortTrend} data-id="element-1571">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-1572" />
            <XAxis dataKey="date" stroke="#6B7280" fontSize={10} hide data-id="element-1573" />
            <YAxis stroke="#6B7280" fontSize={10} data-id="element-1574" />
            <Tooltip contentStyle={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '0.5rem',
            fontSize: '12px'
          }} data-id="element-1575" />
            <Line type="monotone" dataKey="retention" stroke="#8B5CF6" strokeWidth={2} dot={false} data-id="element-1576" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div data-id="element-1577">
        <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1578">
          Overlap App ↔ LMS ↔ Rewards
        </p>
        <div className="grid grid-cols-3 gap-2" data-id="element-1579">
          <div className="bg-gray-50 rounded p-2 text-center" data-id="element-1580">
            <p className="text-xs text-gray-600" data-id="element-1581">Solo App</p>
            <p className="text-sm font-bold text-gray-900" data-id="element-1582">
              {data.overlap.appOnly.toLocaleString()}
            </p>
          </div>
          <div className="bg-gray-50 rounded p-2 text-center" data-id="element-1583">
            <p className="text-xs text-gray-600" data-id="element-1584">Solo LMS</p>
            <p className="text-sm font-bold text-gray-900" data-id="element-1585">
              {data.overlap.lmsOnly.toLocaleString()}
            </p>
          </div>
          <div className="bg-gray-50 rounded p-2 text-center" data-id="element-1586">
            <p className="text-xs text-gray-600" data-id="element-1587">Solo Rewards</p>
            <p className="text-sm font-bold text-gray-900" data-id="element-1588">
              {data.overlap.rewardsOnly.toLocaleString()}
            </p>
          </div>
          <div className="bg-blue-50 rounded p-2 text-center" data-id="element-1589">
            <p className="text-xs text-blue-700" data-id="element-1590">App + LMS</p>
            <p className="text-sm font-bold text-blue-900" data-id="element-1591">
              {data.overlap.appLms.toLocaleString()}
            </p>
          </div>
          <div className="bg-green-50 rounded p-2 text-center" data-id="element-1592">
            <p className="text-xs text-green-700" data-id="element-1593">App + Rewards</p>
            <p className="text-sm font-bold text-green-900" data-id="element-1594">
              {data.overlap.appRewards.toLocaleString()}
            </p>
          </div>
          <div className="bg-purple-50 rounded p-2 text-center" data-id="element-1595">
            <p className="text-xs text-purple-700" data-id="element-1596">Tutti</p>
            <p className="text-sm font-bold text-purple-900" data-id="element-1597">
              {data.overlap.all.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </BentoWidgetCard>;
};
export default RetentionWidget;